<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div
        class="
          d-flex
          pb-6
          align-center
        "
      >
        <h2
          class="display-1"
        >Feeds</h2>

        <v-spacer></v-spacer>

        <TableSearch
          label="Search feed"
          v-model="search"
          @input="doSearch"
        ></TableSearch>

        <v-switch
          v-model="showDisabled"
          label="Show disabled"
          class="pt-0 mt-0 ml-6"
          hide-details
        ></v-switch>

        <NewButton
          to-name="new-feed"
          class="ml-6"
        >Create new feed</NewButton>
      </div>

      <v-data-table
        :headers="headers"
        :items="_fluxes"
        :page="page"
        :items-per-page="itemsPerPage"
        :sort-by.sync="sortBy"
        @update:sort-by="updatePagination"
        :sort-desc.sync="sortDesc"
        @update:sort-desc="updatePagination"
        multi-sort
        hide-default-footer
        :loading="loading"
        @page-count="pageCount = $event"
        @click:row="goToFlux"
      >
        <template v-slot:item.updated_at="{ item }">
          <span
            class="text-no-wrap"
            :id="`focus_${item.id}`"
          >
            {{ new Date(item.updated_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="text-no-wrap">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.provider="{ item }">
          {{ $translate.instant(`FLUX_${item.provider.toUpperCase()}`) }}
        </template>

        <template v-slot:item.status="{ item }">
          <span
            class="font-weight-medium"
            :class="{
              'red--text': item.status === 'disabled',
              'green--text': item.status === 'enabled',
            }"
          >{{ $translate.instant(`FLUX_${item.status.toUpperCase()}`) }}</span>
        </template>

        <template v-slot:item.state="{ item }">
          <span
            class="font-weight-medium"
            :class="{
              'red--text': item.state === 'error',
              'green--text': item.state === 'processed',
              'blue--text': item.state === 'processing',
              'orange--text': item.state === 'pending'
            }"
          >{{ $translate.instant(`FLUX_${item.state.toUpperCase()}`) }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <div
            class="d-flex justify-end"
            v-if="item.status === 'enabled'"
          >
            <CancelFluxButton
              :flux="item"
            ></CancelFluxButton>

            <ProcessFluxButton
              :flux="item"
            ></ProcessFluxButton>
          </div>
        </template>
      </v-data-table>

      <div
        class="py-6"
      >
        <TablePagination
          v-model="page"
          @input="updatePagination"
          :itemsPerPage.sync="itemsPerPage"
          @update:itemsPerPage="updatePagination"
          :pageCount.sync="pageCount"
          :total="fluxes.length"
        ></TablePagination>
      </div>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import TableSearch from '../components/TableSearch.vue'
import NewButton from '../components/NewButton.vue'
import TablePagination from '../components/TablePagination.vue'
import ProcessFluxButton from '../components/ProcessFluxButton.vue'
import CancelFluxButton from '../components/CancelFluxButton.vue'

export default {
  components: {
    ApplicationLayout,
    TableSearch,
    NewButton,
    TablePagination,
    ProcessFluxButton,
    CancelFluxButton
  },
  data() {
    const { itemsPerPage, sortBy, sortDesc, search } = this.$pagination.getOptions('feeds')
    return {
      search,
      pageCount: 0,
      showDisabled: false,
      page: 1,
      loading: true,
      itemsPerPage,
      sortBy,
      sortDesc,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'State', value: 'state' },
        { text: 'Job', value: 'job_id' },
        { text: 'Provider', value: 'provider' },
        { text: 'Last update', value: 'updated_at' },
        { text: 'Creation date', value: 'created_at' },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'end'
        }
      ]
    }
  },
  computed: {
    ...mapState('Fluxes', ['fluxes']),
    _fluxes() {
      return this.fluxes
        .filter((flux) => {
          if (this.showDisabled) return true
          return flux.status === 'enabled'
        })
    }
  },
  async created() {
    await this.$store.dispatch('Fluxes/getAll', { search: this.search })
    const { page } = this.$pagination.getOptions('feeds')
    this.page = page
    this.$pagination.focus()
    this.updatePagination()
    this.loading = false
  },
  methods: {
    updatePagination() {
      this.$pagination.update({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search,
        showDisabled: this.showDisabled
      }, 'feeds')
    },
    goToFlux(flux) {
      this.$router.push({
        name: 'feed',
        params: { id: flux.id }
      })
    },
    async doSearch() {
      this.page = 1
      this.loading = true
      await this.$store.dispatch('Fluxes/getAll', { search: this.search })
      this.loading = false
      this.updatePagination()
    }
  }
}
</script>
